import React from 'react';
import { Link } from 'react-router-dom';

import LegalPage, { Section, List } from '../_gateway/LegalPage';
import { ADDRESS, COMPANY_NUMBER, CONTACT_EMAIL } from '../_gateway/legal-content';

const Terms = () => (
  <LegalPage title="Website Terms of Use" lastUpdated="7 October 2026">

    <Section id="about" number={1} title="About these terms">
      <p>
        These terms apply to your use of www.prmassist.com (the &quot;Website&quot;), which is operated by PRM Assist Limited,
        company number {COMPANY_NUMBER}, {ADDRESS} (&quot;PRM Assist&quot;, &quot;we&quot;, &quot;us&quot;).
      </p>
      <p>
        By using the Website you accept these terms. If you don&apos;t accept them, please don&apos;t use the Website. The PRM Assist app has its
        own terms of use, which apply when you download or use it.
      </p>
    </Section>

    <Section id="purpose" number={2} title="What the Website is for">
      <p>
        The Website gives general information about PRM Assist and the PRM Assist app. You can&apos;t request airport assistance through the
        Website. To request assistance, use the PRM Assist app or contact your airline.
      </p>
    </Section>

    <Section id="not" number={3} title="What we are not">
      <p>
        PRM Assist is not an airline, an airport or an assistance provider. Under Regulation (EC) No 1107/2006, the managing body of each
        airport is responsible for providing assistance to disabled persons and persons with reduced mobility at the airport, and airlines
        are responsible for passing on assistance requests and for assistance on board.
      </p>
      <p>Nothing on the Website is a promise of assistance, a booking, or medical, legal or travel advice.</p>
    </Section>

    <Section id="accuracy" number={4} title="Accuracy of information">
      <p>
        We try to keep Website content accurate and up to date. Airport procedures, timings and airline rules change, so please check the
        details with your airline or airport before you travel.
      </p>
    </Section>

    <Section id="use" number={5} title="Acceptable use">
      <p>You agree not to:</p>
      <List items={[
        'use the Website unlawfully or fraudulently',
        'try to get unauthorised access to the Website or its systems',
        'introduce malware or anything else harmful',
        'scrape or harvest data from the Website',
        'send unsolicited marketing through our forms',
      ]} />
    </Section>

    <Section id="ip" number={6} title="Intellectual property">
      <p>
        We or our licensors own all Website content, including text, graphics, logos and the PRM Assist name and brand. You may view and print
        pages for personal, non-commercial use. Any other use needs our written permission.
      </p>
    </Section>

    <Section id="links" number={7} title="Links">
      <List items={[
        <><strong>Links to other sites:</strong> the Website links to app stores and other third-party sites. We don&apos;t control them and aren&apos;t responsible for their content.</>,
        <><strong>Linking to us:</strong> you may link to our home page if you do so fairly and lawfully, and don&apos;t suggest an endorsement we haven&apos;t given.</>,
      ]} />
    </Section>

    <Section id="availability" number={8} title="Availability">
      <p>
        The Website is provided free of charge and &quot;as is&quot;. We don&apos;t guarantee it will always be available or free of errors.
        We may change or withdraw it at any time.
      </p>
    </Section>

    <Section id="liability" number={9} title="Limitation of liability">
      <List items={[
        'To the extent the law allows, we aren’t liable for any loss that comes from your use of, or reliance on, the Website. This includes indirect or consequential loss.',
        'We aren’t liable for loss caused by airlines, airports or their contractors.',
        'Nothing in these terms limits liability that the law doesn’t allow us to limit, including liability for death or personal injury caused by our negligence, or for fraud. Nothing in these terms affects your statutory rights as a consumer.',
      ]} />
    </Section>

    <Section id="privacy" number={10} title="Privacy and cookies">
      <p>
        Our <Link to="/website-privacy">Website Privacy Policy</Link> and <Link to="/cookies">Cookie Policy</Link> explain how we use personal
        data and cookies on the Website.
      </p>
    </Section>

    <Section id="changes" number={11} title="Changes">
      <p>We may update these terms. The version posted on the Website when you use it is the one that applies.</p>
    </Section>

    <Section id="law" number={12} title="Governing law">
      <p>
        These terms are governed by Irish law, and the Irish courts have jurisdiction. If you&apos;re a consumer living elsewhere in the EU,
        this doesn&apos;t affect the mandatory consumer rights you have in your country of residence, or your right to bring proceedings there.
      </p>
    </Section>

    <Section id="contact" number={13} title="Contact">
      <p><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
    </Section>

  </LegalPage>
);

export default Terms;
